import script from "./OpsManagementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsManagementPage.vue?vue&type=script&setup=true&lang=js"

import "./OpsManagementPage.vue?vue&type=style&index=0&id=39719591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39719591"]])

export default __exports__